import { Layout } from 'antd';
import './GeneralFooter.less';
const { Footer } = Layout;

const GeneralFooter = () => {
    const currentYear = new Date().getFullYear();
    return (
        <Footer className="site-layout-footer">© {currentYear} . (1395512-U). All rights reserved. Powered by CAEZ</Footer>
    )
}

export default GeneralFooter;